<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div class="form-title padding-title">
        {{ title }}
      </div>
      <div class="form-box-body">
        <div class="form-components scroll">
          <div
            class="form_combo_text"
            v-text="text"
          />
          <div
            class="form_label"
            v-text="'Ingresa tu nombre y apellido *'"
          />
          <div class="form__field">
            <label
              for="nombre"
            ><v-icon
              name="user"
              scale="1"
              style="margin: 0 0 5px 0;"
            /></label>
            <input
              id="nombre"
              ref="nombre"
              v-model="nombre"
              autocomplete="off"
              type="text"
              name="nombre"
              value=""
              maxlength="100"
              placeholder=""
              required
              @focus="_clearError"
              @keyup.enter="focusTo('email')"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @change="cleanSpecialChars('nombre', 'name')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingresa tu email *'"
          />
          <div class="form__field">
            <label
              for="email"
            ><v-icon
              name="envelope"
              scale="1"
              style="margin: 0 0 5px 0;"
            /></label>
            <input
              id="email"
              ref="email"
              v-model="email"
              class="email"
              autocomplete="off"
              type="text"
              name="email"
              value=""
              placeholder="usuario@dominio.com"
              required
              maxlength="50"
              @focus="_clearError"
              @keyup.enter="focusTo('npedido')"
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @change="cleanSpecialChars('email', 'email')"
            >
          </div>

          <div
            class="form_label"
            v-text="'Ingresa tu número de pedido *'"
          />
          <div class="form__field">
            <label
              for="npedido"
            ><v-icon
              name="shipping-fast"
              scale="1"
              style="margin: 0 0 5px 0;"
            /></label>
            <input
              id="npedido"
              ref="npedido"
              v-model="npedido"
              autocomplete="off"
              type="text"
              name="npedido"
              value=""
              placeholder="1234"
              maxlength="4"
              required
              @keypress="keyPressCheckSpecialChars($event, 'dbsOrderNumber')"
              @change="cleanSpecialChars('npedido', 'dbsOrderNumber')"
              @focus="_clearError"
            >
          </div>
          <!-- TEXTAREA -->

          <div class="form_label">
            {{ tArea }} *
          </div>
          <div class="score-comments">
            <textarea
              v-model="comentario"
              maxlength="200"
              :placeholder="placeh"
            />
          </div>
        </div>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/shipping-fast'
import utils from '../../utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      comentario: '',
      nombreOrigen: '',
      emailOrigen: '',
      nombre: '',
      email: '',
      npedido: '',
      placeh: '',
      tArea: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'EtienneProblemasPedidosForm') return
      if (e.evento === 'newdata') {
        this.title = e.dato.title ? e.dato.title : 'Etienne Problemas'
        this.tArea = e.dato.tArea ? e.dato.tArea : 'Motivo'
        this.placeh = e.dato.placeh ? e.dato.placeh : 'Ingrese Comentario'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''

        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.npedido = this.npedido || ''
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      if (el === 'pass') this.$refs.password.focus()
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.npedido) {
        this.errormsg = 'Debes ingresar número de pedido'
        return
      }
      if (!this.comentario) {
        this.errormsg = `Debes ingresar un ${this.tArea}`
        return
      }

      const dataToSend = {
        form: 'EtienneProblemasPedidosForm',
        evento: 'sentClick',
        data: {
          fields: {
            firstname: this.nombre,
            email: this.email,
            npedido: this.npedido
            // reclamo: this.comentario,
          }
        }
      }

      // Info hacia el conversation
      if (this.title === 'Producto Dañado') {
        dataToSend.data.type =
          'etienne-problemas-pedido-producto-danado-confirm'
        dataToSend.data.fields.detalle = this.comentario
      } else if (this.title === 'Producto Faltante') {
        dataToSend.data.type =
          'etienne-problemas-pedido-producto-faltante-confirm'
        dataToSend.data.fields.detalle = this.comentario
      } else if (this.title === 'Devolución Pedido') {
        dataToSend.data.type =
          'etienne-problemas-pedido-producto-devolucion-confirm'
        dataToSend.data.fields.motivo = this.comentario
      } else if (this.title === 'Producto Erróneo') {
        dataToSend.data.type =
          'etienne-problemas-pedido-producto-erroneo-confirm'
        dataToSend.data.fields.id_producto = this.comentario
      }
      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'EtienneProblemasPedidosForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}
.form-box-body {
  height: 300px;
  overflow-y: auto;
}
</style>
